









































































































































































import Enumerable from "linq";
import { Component, Mixins, Prop } from "vue-property-decorator";
import { DocumentEditToolControl, IDocumentImageSource } from "../../../../../domain/document";
import { IItem, instanceOfITextLengthValidatable } from "../../../../../domain/document/items";
import { Color, Size } from "../../../../../domain/drawing";
import { ModelEditableMixin } from "../../../../system/mixins";
import RadioButtonSelector from "../../../../system/selectors/RadioButtonSelector.vue";
import EditorMenu from "./edit/EditorMenu.vue";
import { IDrawableItemEditable, EditingDocument } from "../..";
import { DocumentStructureEditableMixin, DocumentEditInformationEditableMixin } from "../../mixins";
import {
  IdentifierViewer,
  GeometryViewer,
  TextValidateLengthViewer,
  NewLinePropertyEditor,
  NewArrowLinePropertyEditor,
  NewBoxLinePropertyEditor,
  NewCirclePropertyEditor,
  NewTrianglePropertyEditor,
  NewCrossPropertyEditor,
  NewTextPropertyEditor,
  NewImagePropertyEditor,
  NewPolylinePropertyEditor,
  NewNewPagePropertyEditor,
} from "../../propertyEditors";
import BehaviorEditor from "../../BehaviorEditor.vue";
import PropertyEditor from "../../PropertyEditor.vue";
import ObjectLocator from "../../ObjectLocator.vue";
import LocatorMenu from "./edit/LocatorMenu.vue";

type ModeContent = ISelectedModeContent | INewLineContent | ILabelContent ;
type ModeContentKey = "addNewImageButton";  // とりあえず必要なものから追加している
type ModeGroupKey = "invisible" | "mix";

interface IModeContent {
  type: string;
  isEnable?: (d: EditingDocument) => boolean;
  isVisible?: (d: EditingDocument, accessor: (getter: (c: DocumentEditToolControl) => boolean) => boolean) => boolean;
  modeContentKey?: ModeContentKey;
  modeGroupKey?: ModeGroupKey;
}

interface ISelectedModeContent extends IModeContent {
  type: "button";
  name: string;
  class: string;
  description: string;
  isLocator: boolean;
}

interface INewLineContent extends IModeContent {
  type: "newLine";
}

interface ILabelContent extends IModeContent {
  type: "label";
  text: string;
}

@Component({
  components: {
    RadioButtonSelector,
    editorMenu: EditorMenu,
    identifierViewer: IdentifierViewer,
    geometryViewer: GeometryViewer,
    textValidateLengthViewer: TextValidateLengthViewer,
    behaviorEditor: BehaviorEditor,
    propertyEditor: PropertyEditor,
    locatorMenu: LocatorMenu,
    newLinePropertyEditor: NewLinePropertyEditor,
    newArrowLinePropertyEditor: NewArrowLinePropertyEditor,
    newBoxLinePropertyEditor: NewBoxLinePropertyEditor,
    newCirclePropertyEditor: NewCirclePropertyEditor,
    newTrianglePropertyEditor: NewTrianglePropertyEditor,
    newCrossPropertyEditor: NewCrossPropertyEditor,
    newTextPropertyEditor: NewTextPropertyEditor,
    newImagePropertyEditor: NewImagePropertyEditor,
    newPolylinePropertyEditor: NewPolylinePropertyEditor,
    newNewPagePropertyEditor: NewNewPagePropertyEditor,
  }
})
export default class EditTool extends Mixins(ModelEditableMixin, DocumentStructureEditableMixin, DocumentEditInformationEditableMixin) {
  editingSource: EditingDocument;

  @Prop()
  focusedObject: IDrawableItemEditable;

  @Prop()
  locator: ObjectLocator;

  @Prop()
  isVisible: boolean;

  @Prop()
  createImageSource: (imageText: string) => Promise<IDocumentImageSource>;

  data(): any {
    const colorPallets = this.$configuration.style.document.editor.colorPallets;
    const pallets = Enumerable.from(colorPallets)
      .where(x => !!x && x !== "")
      .distinct()
      .select(c => new Color(c))
      .toArray();
    return {
      userSelectedMode: EditTool._defaultMode,
      shouldCreateContinuously: false,
      pallet: pallets,
    };
  }
  userSelectedMode: ISelectedModeContent;
  shouldCreateContinuously: boolean;
  pallet: Color[];

  get selectedMode(): ISelectedModeContent {
      return this.isVisible
        ? this.userSelectedMode
        : this.defaultMode;
  }

  set selectedMode(value: ISelectedModeContent) {
      this.userSelectedMode = value;
  }

  get defaultMode(): ISelectedModeContent {
      return EditTool._defaultMode;
  }

  get modes(): ModeContent[] {
    return EditTool._modes.filter(m => this.isVisibleMode(m));
  }

  get editToolControl(): DocumentEditToolControl {
    return (this.editingSource && this.editingSource.attributes)
      ? this.editingSource.attributes.editToolControl
      : null;
  }

  get isObjectPropertyEditable(): boolean {
    return this.editToolControl
      ? this.editToolControl.isObjectStyleEditable
      : true;
  }

  toEditToolModeClass(mode: ISelectedModeContent): string {
    return "edit-tool-mode " + mode.class + (this.isEnableMode(mode) ? "" : " disabled");
  }

  isEnableMode(mode: IModeContent): boolean {
    return this.isDocumentAlreadyInitialized
        && (!mode.isEnable || mode.isEnable(this.editingSource));
  }

  isVisibleMode(mode: IModeContent): boolean {
    if (!mode || !this.isVisibleModeContentByKey(mode) || !this.isVisibleModeContentByGroupKey(mode)) {
      return false;
    }
    const accessor = !this.editToolControl
      ? (getter: (c: DocumentEditToolControl) => boolean) => true
      : (getter: (c: DocumentEditToolControl) => boolean) => getter(this.editToolControl);
    return !mode.isVisible || mode.isVisible(this.editingSource, accessor);
  }

  private isVisibleModeContentByKey(mode: IModeContent): boolean {
    switch (mode.modeContentKey) {
      case "addNewImageButton":
        return this.$configuration.behavior.document.editor.imageDropper.isEnable;
    }
    return true;
  }

  private isVisibleModeContentByGroupKey(mode: IModeContent): boolean {
    switch (mode.modeGroupKey) {
      case "invisible":
        return this.$configuration.behavior.document.editor.newObjects.shouldShowInvisibleGroup;
      case "mix":
        return !this.$configuration.behavior.document.editor.newObjects.shouldShowInvisibleGroup;
    }
    return true;
  }


  isNotMode(mode: IModeContent): boolean {
    return mode.type !== "button";
  }

  private static readonly _modes: ModeContent[] = [
    {
      type: "button",
      name: "オブジェクト選択",
      class: "select",
      description: "配置済のオブジェクトを選択して編集します。",
      isLocator: false,
    },
    {
      type: "button",
      name: "直線オブジェクト追加",
      class: "new-line",
      description: "新しい直線オブジェクトを追加します。",
      isLocator: true,
      isVisible: (d, accessor) => accessor(c => c.isNewLineObjectCreatable),
    },
    {
      type: "button",
      name: "矢印オブジェクト追加",
      class: "new-arrow-line",
      description: "新しい矢印オブジェクトを追加します。",
      isLocator: true,
      isVisible: (d, accessor) => accessor(c => c.isNewLineObjectCreatable),
    },
    {
      type: "button",
      name: "矩形オブジェクト追加",
      class: "new-box-line",
      description: "新しい矩形オブジェクトを追加します。",
      isLocator: true,
      isVisible: (d, accessor) => accessor(c => c.isNewShapeObjectCreatable),
    },
    {
      type: "button",
      name: "円オブジェクト追加",
      class: "new-circle",
      description: "新しい円オブジェクトを追加します。",
      isLocator: true,
      isVisible: (d, accessor) => accessor(c => c.isNewShapeObjectCreatable),
    },
    {
      type: "button",
      name: "三角形オブジェクト追加",
      class: "new-triangle",
      description: "新しい三角形オブジェクトを追加します。",
      isLocator: true,
      isVisible: (d, accessor) => accessor(c => c.isNewShapeObjectCreatable),
    },
    {
      type: "button",
      name: "クロスオブジェクト追加",
      class: "new-cross",
      description: "新しいクロスオブジェクトを追加します。",
      isLocator: true,
      isVisible: (d, accessor) => accessor(c => c.isNewShapeObjectCreatable),
    },
    {
      type: "button",
      name: "テキストオブジェクト追加",
      class: "new-text",
      description: "新しいテキストオブジェクトを追加します。",
      isLocator: true,
      isVisible: (d, accessor) => accessor(c => c.isNewTextObjectCreatable),
    },
    {
      type: "button",
      name: "付箋オブジェクト追加",
      class: "new-tag",
      description: "新しい付箋オブジェクトを追加します。",
      isLocator: true,
      isVisible: (d, accessor) => accessor(c => c.isNewTextObjectCreatable),
      modeGroupKey: "mix",
    },
    {
      type: "button",
      name: "画像オブジェクト追加",
      class: "new-image",
      description: "新しい画像オブジェクトを追加します。",
      isLocator: true,
      isVisible: (d, accessor) => accessor(c => c.isNewImageObjectCreatable),
      modeContentKey: "addNewImageButton"
    },
    {
      type: "button",
      name: "自由曲線オブジェクト追加",
      class: "new-polyline",
      description: "新しい自由曲線オブジェクトを追加します。",
      isLocator: true,
      // V1では自由描画ボタンが表示されていたので、とりあえず印刷するほうのボタンは表示させている
    },
    {
      type: "button",
      name: "改頁オブジェクト追加",
      class: "new-page",
      description: "新しい改頁オブジェクトを追加します。",
      isLocator: true,
      isEnable: d => d && d.currentSection && d.currentSection.isPageSplittable,
      isVisible: (d, accessor) => d && d.sections && d.sections.some(s => s.isPageSplittable),
    },
    {
      type: "newLine",
      isVisible: (d, accessor) => accessor(c => c.isNewTextObjectCreatable || c.isNewLineObjectCreatable || c.isNewShapeObjectCreatable),  // これ以降に何か表示されるかどうか
      modeGroupKey: "invisible",
    },
    {
      type: "label",
      text: "既定値:印刷されない",
      isVisible: (d, accessor) => accessor(c => c.isNewTextObjectCreatable || c.isNewLineObjectCreatable || c.isNewShapeObjectCreatable),  // これ以降に何か表示されるかどうか
      modeGroupKey: "invisible",
    },
    {
      type: "newLine",
      isVisible: (d, accessor) => accessor(c => c.isNewTextObjectCreatable || c.isNewLineObjectCreatable || c.isNewShapeObjectCreatable),  // これ以降に何か表示されるかどうか
      modeGroupKey: "invisible",
    },
    {
      type: "button",
      name: "直線オブジェクト(既定値:印刷されない)追加",
      class: "new-line",
      description: "新しい直線オブジェクト(既定値:印刷されない)を追加します。",
      isLocator: true,
      isVisible: (d, accessor) => accessor(c => c.isNewLineObjectCreatable),
      modeGroupKey: "invisible",
    },
    {
      type: "button",
      name: "矢印オブジェクト(既定値:印刷されない)追加",
      class: "new-arrow-line",
      description: "新しい矢印オブジェクト(既定値:印刷されない)を追加します。",
      isLocator: true,
      isVisible: (d, accessor) => accessor(c => c.isNewLineObjectCreatable),
      modeGroupKey: "invisible",
    },
    {
      type: "button",
      name: "矩形オブジェクト(既定値:印刷されない)追加",
      class: "new-box-line",
      description: "新しい矩形オブジェクト(既定値:印刷されない)を追加します。",
      isLocator: true,
      isVisible: (d, accessor) => accessor(c => c.isNewShapeObjectCreatable),
      modeGroupKey: "invisible",
    },
    {
      type: "button",
      name: "円オブジェクト(既定値:印刷されない)追加",
      class: "new-circle",
      description: "新しい円オブジェクト(既定値:印刷されない)を追加します。",
      isLocator: true,
      isVisible: (d, accessor) => accessor(c => c.isNewShapeObjectCreatable),
      modeGroupKey: "invisible",
    },
    {
      type: "button",
      name: "三角形オブジェクト(既定値:印刷されない)追加",
      class: "new-triangle",
      description: "新しい三角形オブジェクト(既定値:印刷されない)を追加します。",
      isLocator: true,
      isVisible: (d, accessor) => accessor(c => c.isNewShapeObjectCreatable),
      modeGroupKey: "invisible",
    },
    {
      type: "button",
      name: "クロスオブジェクト(既定値:印刷されない)追加",
      class: "new-cross",
      description: "新しいクロスオブジェクト(既定値:印刷されない)を追加します。",
      isLocator: true,
      isVisible: (d, accessor) => accessor(c => c.isNewShapeObjectCreatable),
      modeGroupKey: "invisible",
    },
    {
      type: "button",
      name: "自由曲線オブジェクト(既定値:印刷されない)追加",
      class: "new-polyline",
      description: "新しい自由曲線オブジェクト(既定値:印刷されない)を追加します。",
      isLocator: true,
      isVisible: (d, accessor) => accessor(c => c.isNewShapeObjectCreatable),
      modeGroupKey: "invisible",
    },
    {
      type: "button",
      name: "付箋オブジェクト追加",
      class: "new-tag",
      description: "新しい付箋オブジェクトを追加します。",
      isLocator: true,
      isVisible: (d, accessor) => accessor(c => c.isNewTextObjectCreatable),
      modeGroupKey: "invisible",
    },
  ];

  private static readonly _defaultMode: ISelectedModeContent = EditTool._modes[0] as ISelectedModeContent;

  shouldShowContent(name: string): boolean {
    return this.selectedMode && (this.selectedMode.name === name);
  }

  get isDocumentAlreadyInitialized(): boolean {
    return this.isSourceEnable
      && this.editingSource.isAlreadyInitialized;
  }

  get isItemSelected(): boolean {
    return !!this.lastFocusedItem;
  }

  get shouldShowTextValidateLength(): boolean {
    return !!instanceOfITextLengthValidatable(this.lastFocusedItem);
  }

  get isEditing(): boolean {
    return !this.isLocating;
  }

  get isLocating(): boolean {
    return !!this.selectedMode
      && this.selectedMode.isLocator;
  }

  onItemUpdated(updated: IItem): void {
    this.updateItem(updated);
  }

  onItemAdded(added: IItem): void {
    this.addItem(added);
    if (!this.shouldCreateContinuously) {
      this.selectedMode = this.defaultMode;
    }
  }

  get sectionSize(): Size {
    return (this.editingSource && this.editingSource.currentSection)
      ? this.editingSource.currentSection.size
      : null;
  }
}
